/* eslint-disable  no-useless-escape */
import * as Yup from 'yup'
const moneyRegex = /^[0-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/
const emailRegex = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/ // eslint-disable-line no-useless-escape
const zipCodeReqExp = /^[0-9]{5}(-[0-9]{4})*$/
const phoneRegex = /^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/
const taxIdNumberRegex = /^[0-9]{9}$/
const npiRegex = /^[0-9]{10}$/
const integerRegex = /^[0-9]*$/
const extensionRegex = /^[0-9]{3,4}$/

export const LocationGeneralInfoSchema = Yup.object().shape({
  name: Yup.string().nullable()
    .required('This field is required.')
    .max(255, 'Please use 255 characters or less.'),
  npi: Yup.string().nullable()
    .matches(npiRegex, 'Please specify a valid NPI number.'),
  accessibility: Yup.array().nullable().required('This field is required.'),
  language: Yup.array().nullable().required('This field is required.'),
  targetGroup: Yup.array().nullable().required('This field is required.'),
  county: Yup.array().nullable().required('This field is required.')
})

export const LocationPersonnelSchema = Yup.object().shape({
  monday: Yup.boolean().nullable().oneOf([true], 'This field is required'),
  mondayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (this.parent.monday && !this.parent.mondayNA && value === null) return false
      return true
    }),
  mondayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('mondayStart'), 'End time can\'t be before start time.')
    .test('isRequired', 'This field is required.', function (value) {
      if (this.parent.monday && !this.parent.mondayNA && value === null) return false
      return true
    }),
  tuesday: Yup.boolean().nullable().oneOf([true], 'This field is required'),
  tuesdayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (this.parent.tuesday && !this.parent.tuesdayNA && value === null) return false
      return true
    }),
  tuesdayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('tuesdayStart'), 'End time can\'t be before start time.')
    .test('isRequired', 'This field is required.', function (value) {
      if (this.parent.tuesday && !this.parent.tuesdayNA && value === null) return false
      return true
    }),
  wednesday: Yup.boolean().nullable().oneOf([true], 'This field is required'),
  wednesdayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (this.parent.wednesday && !this.parent.wednesdayNA && value === null) return false
      return true
    }),
  wednesdayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('wednesdayStart'), 'End time can\'t be before start time.')
    .test('isRequired', 'This field is required.', function (value) {
      if (this.parent.wednesday && !this.parent.wednesdayNA && value === null) return false
      return true
    }),
  thursday: Yup.boolean().nullable().oneOf([true], 'This field is required'),
  thursdayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (this.parent.thursday && !this.parent.thursdayNA && value === null) return false
      return true
    }),
  thursdayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('thursdayStart'), 'End time can\'t be before start time.')
    .test('isRequired', 'This field is required.', function (value) {
      if (this.parent.thursday && !this.parent.thursdayNA && value === null) return false
      return true
    }),
  friday: Yup.boolean().nullable().oneOf([true], 'This field is required'),
  fridayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (this.parent.friday && !this.parent.fridayNA && value === null) return false
      return true
    }),
  fridayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('fridayStart'), 'End time can\'t be before start time.')
    .test('isRequired', 'This field is required.', function (value) {
      if (this.parent.friday && !this.parent.fridayNA && value === null) return false
      return true
    }),
  saturday: Yup.boolean().nullable(),
  saturdayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .when(('saturday'), (saturday, schema) => saturday ? schema.required('This field is required.') : schema),
  saturdayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('saturdayStart'), 'End time can\'t be before start time.')
    .when(('saturday'), (saturday, schema) => saturday ? schema.required('This field is required.') : schema),
  sunday: Yup.boolean().nullable(),
  sundayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .when(('sunday'), (sunday, schema) => sunday ? schema.required('This field is required.') : schema),
  sundayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('sundayStart'), 'End time can\'t be before start time.')
    .when(('sunday'), (sunday, schema) => sunday ? schema.required('This field is required.') : schema),
  holiday: Yup.string().nullable()
    .max(255, 'Please use 255 characters or less.'),
  providerContactTypeId: Yup.number().nullable(),
  firstName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 50 characters or less.'),
  lastName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 50 characters or less.'),
  emailAddress: Yup.string().nullable()
    .required('This field is required.')
    .matches(emailRegex, 'Please specify a valid email.')
    .max(100, 'Please use 100 characters or less.'),
  bulkEmails: Yup.boolean(),
  phoneNumber: Yup.string().nullable()
    .matches(phoneRegex, 'Please specify a valid phone number.')
    .when(('extension'), (extension, schema) => extension ? schema.required('This field is required.') : schema),
  extension: Yup.string().nullable()
    .matches(extensionRegex, 'Please specify a valid extension.'),
  // faxNumber: Yup.string().nullable()
  //   .matches(npiFaxRegex, 'Please specify a valid fax number.'),
})

export const LocationContactSchema = Yup.object().shape({
  generalEmailAddress: Yup.string().nullable()
    .required('This field is required.')
    .matches(emailRegex, 'Please specify a valid email.')
    .max(100, 'Please use 100 characters or less.'),
  website: Yup.string().nullable()
    .max(100, 'Please use 100 characters or less.'),
  generalPhoneNumber: Yup.string().nullable()
    .matches(phoneRegex, 'Please specify a valid phone number.')
    .required('This field is required.'),
  generalExtension: Yup.string().nullable()
    .matches(extensionRegex, 'Please specify a valid extension.'),
  // generalFaxNumber: Yup.string().nullable()
  //   .matches(npiFaxRegex, 'Please specify a valid fax number.'),
  address: Yup.object().nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (value === null && !this.parent.overrideAddressValidation) return false
      return true
    }),
  addressEntries: Yup.object().nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (value === null && !this.parent.overrideAddressValidation) return false
      return true
    }),
  address1: Yup.string().nullable()
    .required('This field is required.')
    .max(100, 'Please use 100 characters or less.'),
  address2: Yup.string().nullable()
    .max(100, 'Please use 100 characters or less.'),
  city: Yup.string().nullable()
    .required('This field is required.'),
  state: Yup.string().nullable()
    .max(2, 'Please use 2 characters')
    .required('This field is required.'),
  zipCode: Yup.string().nullable()
    .required('This field is required.')
    .matches(zipCodeReqExp, 'Please specify a valid zip code.')
})

export const CreateAccountSchema = Yup.object().shape({
  firstName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 50 characters or less.'),
  lastName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 50 characters or less.'),
  email: Yup.string().nullable()
    .required('This field is required.')
    .matches(emailRegex, 'Please specify a valid email.')
    .max(100, 'Please use 100 characters or less.'),
})

export const WelcomeModalSchema = Yup.object().shape({
  applicationType: Yup.string().nullable()
    .required('This field is required.'),
  '12BedCertification': Yup.string().nullable()
    .when(('applicationType'), (applicationType, schema) => applicationType === 'residential' ? schema.required('This field is required.') : schema),
})

const generalInfoProps = {
  agencyName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 255 characters or less.'),
  legalEntity: Yup.string().nullable()
    .max(50, 'Please use 255 characters or less.'),
  serviceTypes: Yup.array().nullable()
    .required('This field is required.'),
  address: Yup.object().nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (value === null && !this.parent.overrideAddressValidation) return false
      return true
    }),
  addressEntries: Yup.object().nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (value === null && !this.parent.overrideAddressValidation) return false
      return true
    }),
  address1: Yup.string().nullable()
    .required('This field is required.')
    .max(100, 'Please use 100 characters or less.'),
  address2: Yup.string().nullable()
    .max(100, 'Please use 100 characters or less.'),
  city: Yup.string().nullable()
    .required('This field is required.'),
  state: Yup.string().nullable()
    .required('This field is required.'),
  zipCode: Yup.string().nullable()
    .required('This field is required.')
    .matches(zipCodeReqExp, 'Please specify a valid zip code.'),
  contactFirstName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 50 characters or less.'),
  contactLastName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 50 characters or less.'),
  emailAddress: Yup.string().nullable()
    .required('This field is required.')
    .matches(emailRegex, 'Please specify a valid email.')
    .max(100, 'Please use 100 characters or less.'),
  website: Yup.string().nullable()
    .max(100, 'Please use 100 characters or less.'),
  phoneNumber: Yup.string().nullable()
    .matches(phoneRegex, 'Please specify a valid phone number.')
    .required('This field is required.'),
  extension: Yup.string().nullable()
    .matches(extensionRegex, 'Please specify a valid extension.'),
  faxNumber: Yup.number().nullable()
    .typeError('Please specify a valid number.'),
  taxIdNumber: Yup.string().nullable()
    .required('This field is required.')
    .matches(taxIdNumberRegex, 'Please specify a valid ID.'),
  qualifier: Yup.string().nullable()
    .required('This field is required.'),
  npi: Yup.string().nullable()
    .matches(npiRegex, 'Please specify a valid NPI number.'),
  medicaidId: Yup.string().nullable()
    .matches(/^[0-9]+$/, 'Please specify a valid ID.'),
  medicareId: Yup.string().nullable()
    .max(50, 'Please use 50 characters or less.'),
  providerAgencyId: Yup.string().nullable()
    .max(50, 'Please use 50 characters or less.')
    .matches(/^[0-9]+$/, 'Please specify a valid ID.'),
  billingName: Yup.string().nullable()
    .required('This field is required.')
    .max(255, 'Please use 255 characters or less.'),
  billingAddress: Yup.object().nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (value === null && !this.parent.billingOverrideAddressValidation) return false
      return true
    }),
  billingEntries: Yup.object().nullable()
    .test('isRequired', 'This field is required.', function (value) {
      if (value === null && !this.parent.billingOverrideAddressValidation) return false
      return true
    }),
  billingAddress1: Yup.string().nullable()
    .required('This field is required.')
    .max(100, 'Please use 100 characters or less.'),
  billingAddress2: Yup.string().nullable()
    .max(100, 'Please use 100 characters or less.'),
  billingCity: Yup.string().nullable().required('This field is required.'),
  billingState: Yup.string().nullable().required('This field is required.'),
  billingZipCode: Yup.string().nullable()
    .required('This field is required.')
    .matches(zipCodeReqExp, 'Please specify a valid zip code.'),
  experienceYears: Yup.string().nullable()
    .matches(moneyRegex, 'Please specify a valid number.')
    .when('newBusiness', (newBusiness, schema) => newBusiness === 'NO' ? schema.required('This field is required.') : schema),
  relevantExperience: Yup.string()
    .when('newBusiness', (newBusiness, schema) => newBusiness === 'YES' ? schema.required('This field is required.') : schema)
    .max(255, 'Please use 255 characters or less.'),
  serviceDetails: Yup.string().nullable()
    .max(255, 'Please use 255 characters or less.'),
  monday: Yup.boolean().nullable().oneOf([true], 'This field is required'),
  mondayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .when('monday', {
      is: true,
      then: Yup.date().when('mondayNA', (mondayNA, schema) => !mondayNA ? schema.required('This field is required.') : schema)
    }),
  mondayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('mondayStart'), 'End time can\'t be before start time.')
    .when('monday', {
      is: true,
      then: Yup.date().when('mondayNA', (mondayNA, schema) => !mondayNA ? schema.required('This field is required.') : schema)
    }),
  tuesday: Yup.boolean().nullable().oneOf([true], 'This field is required'),
  tuesdayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .when('tuesday', {
      is: true,
      then: Yup.date().when('tuesdayNA', (mondayNA, schema) => !mondayNA ? schema.required('This field is required.') : schema)
    }),
  tuesdayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('tuesdayStart'), 'End time can\'t be before start time.')
    .when('tuesday', {
      is: true,
      then: Yup.date().when('tuesdayNA', (mondayNA, schema) => !mondayNA ? schema.required('This field is required.') : schema)
    }),
  wednesday: Yup.boolean().nullable().oneOf([true], 'This field is required'),
  wednesdayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .when('wednesday', {
      is: true,
      then: Yup.date().when('wednesdayNA', (mondayNA, schema) => !mondayNA ? schema.required('This field is required.') : schema)
    }),
  wednesdayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('wednesdayStart'), 'End time can\'t be before start time.')
    .when('wednesday', {
      is: true,
      then: Yup.date().when('wednesdayNA', (mondayNA, schema) => !mondayNA ? schema.required('This field is required.') : schema)
    }),
  thursday: Yup.boolean().nullable().oneOf([true], 'This field is required'),
  thursdayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .when('thursday', {
      is: true,
      then: Yup.date().when('thursdayNA', (mondayNA, schema) => !mondayNA ? schema.required('This field is required.') : schema)
    }),
  thursdayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('thursdayStart'), 'End time can\'t be before start time.')
    .when('thursday', {
      is: true,
      then: Yup.date().when('thursdayNA', (mondayNA, schema) => !mondayNA ? schema.required('This field is required.') : schema)
    }),
  friday: Yup.boolean().nullable().oneOf([true], 'This field is required'),
  fridayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .when('friday', {
      is: true,
      then: Yup.date().when('fridayNA', (mondayNA, schema) => !mondayNA ? schema.required('This field is required.') : schema)
    }),
  fridayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('fridayStart'), 'End time can\'t be before start time.')
    .when('friday', {
      is: true,
      then: Yup.date().when('fridayNA', (mondayNA, schema) => !mondayNA ? schema.required('This field is required.') : schema)
    }),
  saturday: Yup.boolean().nullable(),
  saturdayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .when(('saturday'), (saturday, schema) => saturday ? schema.required('This field is required.') : schema),
  saturdayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('saturdayStart'), 'End time can\'t be before start time.')
    .when(('saturday'), (saturday, schema) => saturday ? schema.required('This field is required.') : schema),
  sunday: Yup.boolean().nullable(),
  sundayStart: Yup.date().typeError('Please specify a valid time.').nullable()
    .when(('sunday'), (sunday, schema) => sunday ? schema.required('This field is required.') : schema),
  sundayEnd: Yup.date().typeError('Please specify a valid time.').nullable()
    .min( Yup.ref('sundayStart'), 'End time can\'t be before start time.')
    .when(('sunday'), (sunday, schema) => sunday ? schema.required('This field is required.') : schema),
  holiday: Yup.string().nullable()
    .max(255, 'Please use 255 characters or less.'),
  targetGroups: Yup.array().nullable()
    .required('This field is required.'),
  accessibility: Yup.array().nullable()
    .required('This field is required.'),
  genderServed: Yup.string().nullable()
    .required('This field is required.'),
  languages: Yup.array().nullable()
    .required('This field is required.'),
  wavierCompliant: Yup.array().nullable()
    .required('This field is required.'),
  counties: Yup.array().nullable()
    .required('This field is required.'),
  overnightCareId: Yup.number().nullable(),
  staffingModelId: Yup.number().nullable(),
  handicappedAccessible: Yup.boolean().nullable(),
  equityInclusionTraining: Yup.boolean().nullable(),
  raceId: Yup.number().nullable()
    .required('This field is required.'),
  ethnicityId: Yup.number().nullable()
    .required('This field is required.'),
  publishRaceEthnicity: Yup.boolean().nullable(),
}

export const ResidentialGeneralInfoSchema = Yup.object().shape({
  ...generalInfoProps,
  residentialProviderApplicants: Yup.string().nullable()
    .required('This field is required'),
  licensedCapacity: Yup.string().nullable()
    .matches(integerRegex, 'Please specify a valid number.')
})

export const NonResidentialGeneralInfoSchema = Yup.object().shape({
  ...generalInfoProps,
  licensedCapacity: Yup.string().nullable()
    .matches(integerRegex, 'Please specify a valid number.')
})

export const ContactInfoSchema = Yup.object().shape({
  contractingFirstName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 50 characters or less.'),
  contractingLastName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 50 characters or less.'),
  contractingPhoneNumber: Yup.string().nullable()
    .required('This field is required.')
    .matches(phoneRegex, 'Please specify a valid phone number.'),
  contractingExtension: Yup.string().nullable()
    .matches(extensionRegex, 'Please specify a valid extension.'),
  contractingFax: Yup.number().nullable()
    .typeError('Please specify a valid number.'),
  contractingEmailAddress: Yup.string().nullable()
    .required('This field is required.')
    .matches(emailRegex, 'Please specify a valid email.')
    .max(100, 'Please use 100 characters or less.'),
  administratorFirstName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 50 characters or less.'),
  administratorLastName: Yup.string().nullable()
    .required('This field is required.')
    .max(50, 'Please use 50 characters or less.'),
  administratorPhoneNumber: Yup.string().nullable()
    .required('This field is required.')
    .matches(phoneRegex, 'Please specify a valid phone number.'),
  administratorExtension: Yup.string().nullable()
    .matches(extensionRegex, 'Please specify a valid extension.'),
  administratorFax: Yup.number().nullable()
    .typeError('Please specify a valid number.'),
  administratorEmailAddress: Yup.string().nullable()
    .matches(emailRegex, 'Please specify a valid email.')
    .max(100, 'Please use 100 characters or less.')
    .required('This field is required.'),
  billingFirstName: Yup.string().nullable()
    .max(50, 'Please use 50 characters or less.')
    .required('This field is required.'),
  billingLastName: Yup.string().nullable()
    .max(50, 'Please use 50 characters or less.')
    .required('This field is required.'),
  billingPhoneNumber: Yup.string().nullable()
    .matches(phoneRegex, 'Please specify a valid phone number.')
    .required('This field is required.'),
  billingExtension: Yup.string().nullable()
    .matches(extensionRegex, 'Please specify a valid extension.'),
  billingFax: Yup.number().nullable()
    .typeError('Please specify a valid number.'),
  billingEmailAddress: Yup.string().nullable()
    .matches(emailRegex, 'Please specify a valid email.')
    .max(100, 'Please use 100 characters or less.')
    .required('This field is required.'),
  qualityFirstName: Yup.string().nullable()
    .max(50, 'Please use 50 characters or less.')
    .required('This field is required.'),
  qualityLastName: Yup.string().nullable()
    .max(50, 'Please use 50 characters or less.')
    .required('This field is required.'),
  qualityPhoneNumber: Yup.string().nullable()
    .matches(phoneRegex, 'Please specify a valid phone number.')
    .required('This field is required.'),
  qualityExtension: Yup.string().nullable()
    .matches(extensionRegex, 'Please specify a valid extension.'),
  qualityFax: Yup.number().nullable()
    .typeError('Please specify a valid number.'),
  qualityEmailAddress: Yup.string().nullable()
    .matches(emailRegex, 'Please specify a valid email.')
    .max(100, 'Please use 100 characters or less.')
    .required('This field is required.'),
  assessmentFirstName: Yup.string().nullable()
    .max(50, 'Please use 50 characters or less.')
    .required('This field is required.'),
  assessmentLastName: Yup.string().nullable()
    .max(50, 'Please use 50 characters or less.')
    .required('This field is required.'),
  assessmentPhoneNumber: Yup.string().nullable()
    .matches(phoneRegex, 'Please specify a valid phone number.')
    .required('This field is required.'),
  assessmentExtension: Yup.string().nullable()
    .matches(extensionRegex, 'Please specify a valid extension.'),
  assessmentFax: Yup.number().nullable()
    .typeError('Please specify a valid number.'),
  assessmentEmailAddress: Yup.string().nullable()
    .matches(emailRegex, 'Please specify a valid email.')
    .max(100, 'Please use 100 characters or less.')
    .required('This field is required.'),
})

export const OrganizationalInfoSchema = Yup.object().shape({
  culturalCompetency: Yup.string().nullable()
    .required('This field is required.')
    .max(255, 'Please use 255 characters or less.')
    .required('This field is required.'),
  serviceLimitations: Yup.string().nullable()
    .required('This field is required.')
    .max(255, 'Please use 255 characters or less.')
    .required('This field is required.'),
  qualityAssurancePlan: Yup.string().nullable()
    .required('This field is required.')
    .max(255, 'Please use 255 characters or less.')
    .required('This field is required.')
    .required('This field is required.'),
  trainingPlan: Yup.string().nullable()
    .required('This field is required.')
    .max(255, 'Please use 255 characters or less.')
    .required('This field is required.'),
  payLevelsAndBenefits: Yup.string().nullable()
    .required('This field is required.')
    .max(255, 'Please use 255 characters or less.')
    .required('This field is required.'),
  unintendedEventsPolicy: Yup.string().nullable()
    .required('This field is required.')
    .max(255, 'Please use 255 characters or less.')
    .required('This field is required.'),
  businessYears: Yup.string().nullable()
    .required('This field is required.')
    .max(255, 'Please use 255 characters or less.')
    .required('This field is required.'),
})

export const DisclosureQuestionsSchema = Yup.object().shape({
  disclosureQuestion1: Yup.string().nullable()
    .required('This field is required.'),
  disclosureQuestion1Explanation: Yup.string().nullable()
    .when('disclosureQuestion1', (disclosureQuestion1, schema) => disclosureQuestion1 === 'YES' ? schema.required('This field is required.') : schema)
    .max(255, 'Please use 255 characters or less.'),
  disclosureQuestion2: Yup.string().nullable()
    .required('This field is required.'),
  disclosureQuestion2Explanation: Yup.string().nullable()
    .when('disclosureQuestion2', (disclosureQuestion2, schema) => disclosureQuestion2 === 'YES' ? schema.required('This field is required.') : schema)
    .max(255, 'Please use 255 characters or less.'),
  disclosureQuestion3: Yup.string().nullable()
    .required('This field is required.'),
  disclosureQuestion3Explanation: Yup.string().nullable()
    .when('disclosureQuestion3', (disclosureQuestion3, schema) => disclosureQuestion3 === 'YES' ? schema.required('This field is required.') : schema)
    .max(255, 'Please use 255 characters or less.'),
  disclosureQuestion4: Yup.string().nullable()
    .required('This field is required.'),
  disclosureQuestion4Explanation: Yup.string().nullable()
    .when('disclosureQuestion4', (disclosureQuestion4, schema) => disclosureQuestion4 === 'YES' ? schema.required('This field is required.') : schema)
    .max(255, 'Please use 255 characters or less.'),
  disclosureQuestion5: Yup.string().nullable()
    .required('This field is required.'),
  disclosureQuestion5Explanation: Yup.string().nullable()
    .when('disclosureQuestion5', (disclosureQuestion5, schema) => disclosureQuestion5 === 'YES' ? schema.required('This field is required.') : schema)
    .max(255, 'Please use 255 characters or less.'),
  disclosureQuestion6: Yup.string().nullable()
    .required('This field is required.'),
  disclosureQuestion6Explanation: Yup.string().nullable()
    .when('disclosureQuestion6', (disclosureQuestion6, schema) => disclosureQuestion6 === 'YES' ? schema.required('This field is required.') : schema)
    .max(255, 'Please use 255 characters or less.'),
  disclosureQuestion7: Yup.string().nullable()
    .required('This field is required.'),
  disclosureQuestion7Explanation: Yup.string().nullable()
    .when('disclosureQuestion7', (disclosureQuestion7, schema) => disclosureQuestion7 === 'YES' ? schema.required('This field is required.') : schema)
    .max(255, 'Please use 255 characters or less.'),
})

const certificationFileNameIsValid = (value) => {
  if (value && value.length > 0) {
    return value.every(item => {
      const fileNameExp = /[/\\?*:|"<>]/g
      return !fileNameExp.test(item.name)
    })
  }
  return true
}

const requiredCertificationFiles = (modalName, uploadedFieldName, notApplicableField = '') => Yup.array()
  .when(('modalType'), (modalType, schema) => {
    if (modalType !== modalName) {
      return schema
    }

    const requireFiles = (currentSchema) => currentSchema.when(('removeFileList'), (removeFileList, innerSchema) => removeFileList && removeFileList.length > 0 ?
      innerSchema.when((uploadedFieldName), (uploadedFiles, fileSchema) => uploadedFiles && uploadedFiles.length > removeFileList.length ? fileSchema : fileSchema.min(1, 'This field is required')) :
      innerSchema.min(1, 'This field is required'))

    if (notApplicableField) {
      return schema.when((notApplicableField), (notApplicable, innerSchema) => notApplicable ? innerSchema : requireFiles(innerSchema))
    }

    return requireFiles(schema)
  })
  .test(uploadedFieldName, 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', certificationFileNameIsValid)

const certificationUploadFields = {
  hcbsComplianceDocumentation: requiredCertificationFiles('HCBS Compliance Documentation', 'hcbsComplianceDocumentationFile'),
  leaseAgreement: requiredCertificationFiles('Mortgage or Lease Agreement', 'leaseAgreementFile'),
  programStatement: requiredCertificationFiles('Program Statement', 'programStatementFile'),
  emergencyEvacuationPlan: requiredCertificationFiles('Emergency Evacuation Plan', 'emergencyEvacuationPlanFile'),
  successionPlanning: requiredCertificationFiles('Succession Planning', 'successionPlanningFile'),
  healthAttestation: requiredCertificationFiles('Health Attestation', 'healthAttestationFile'),
  healthAssessment: requiredCertificationFiles('Health Assessment', 'healthAssessmentFile', 'healthAssessmentNotApplicable'),
  driversLicenseAttestation: requiredCertificationFiles('Driver\'s License Attestation', 'driversLicenseAttestationFile'),
  furnaceInspection: requiredCertificationFiles('Furnace Inspection', 'furnaceInspectionFile'),
  fireInspection: requiredCertificationFiles('Fire Inspection', 'fireInspectionFile'),
  fireExtinguisherInvoice: requiredCertificationFiles('Fire Extinguisher Invoice', 'fireExtinguisherInvoiceFile'),
  wellTest: requiredCertificationFiles('Well Test', 'wellTestFile', 'wellTestNotApplicable'),
  fireDiagram: requiredCertificationFiles('Fire Diagram', 'fireDiagramFile'),
  governmentIssuedPhotoId: requiredCertificationFiles('Government Issued Photo ID', 'governmentIssuedPhotoIdFile'),
  petVaccinations: requiredCertificationFiles('Pet Vaccinations', 'petVaccinationsFile', 'petVaccinationsNotApplicable'),
  prescriptionMedicationStoragePolicy: requiredCertificationFiles('Prescription Medication Storage Policy', 'prescriptionMedicationStoragePolicyFile'),
  medicationAdministrationPolicy: requiredCertificationFiles('Medication Administration Policy', 'medicationAdministrationPolicyFile'),
  trainingPlan: requiredCertificationFiles('Training Plan Policy and Procedure', 'trainingPlanFile'),
  proofOfCurrentTraining: requiredCertificationFiles('Proof of Current Training', 'proofOfCurrentTrainingFile'),
  proofOfFinances: requiredCertificationFiles('Proof of Finances', 'proofOfFinancesFile'),
}

export const UploadModalSchema = Yup.object().shape({
  w9: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Copy of W-9' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('w9File'), (w9File, schema) => w9File.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('w9File', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  facilityLicense: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Copy of Facility Licensure' ? 
      schema.when(('doesNotHaveFacilityLicense'), (doesNotHaveFacilityLicense, schema) => doesNotHaveFacilityLicense ? schema : 
        schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
          schema.when(('facilityLicenseFile'), (facilityLicenseFile, schema) => facilityLicenseFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
          schema.min(1, 'This field is required'))
      ) : schema
    ).test('facilityLicenseFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  certificateInsurance: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Copy of Certificate of Insurance' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('certificateInsuranceFile'), (certificateInsuranceFile, schema) => certificateInsuranceFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('certificateInsuranceFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  debarmentAttestationLetter: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Debarment Attestation Letter' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('debarmentAttestationLetterFile'), (debarmentAttestationLetterFile, schema) => debarmentAttestationLetterFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('debarmentAttestationLetterFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  trainingAttestationLetter: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Training Attestation Letter' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('trainingAttestationLetterFile'), (trainingAttestationLetterFile, schema) => trainingAttestationLetterFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('trainingAttestationLetterFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  civilRightsComplianceAttestationLetter: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Civil Rights Compliance Attestation Letter' ? 
      schema.when(('doesNotApply'), (doesNotApply, schema) => doesNotApply ? schema : 
        schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
          schema.when(('civilRightsComplianceAttestationLetterFile'), (civilRightsComplianceAttestationLetterFile, schema) => civilRightsComplianceAttestationLetterFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
          schema.min(1, 'This field is required'))
      ) : schema
    ).test('civilRightsComplianceAttestationLetterFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  residentialWorksheet: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Residential Worksheets' ? 
      schema.when(('residentialWorksheetDoesNotApply'), (residentialWorksheetDoesNotApply, schema) => residentialWorksheetDoesNotApply ? schema : 
        schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
          schema.when(('residentialWorksheetFile'), (residentialWorksheetFile, schema) => residentialWorksheetFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
          schema.min(1, 'This field is required'))
      ) : 
      schema
    ).test('residentialWorksheetFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  certificationApplication: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Certification Application' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('certificationApplicationFile'), (certificationApplicationFile, schema) => certificationApplicationFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('certificationApplicationFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  individualQuestionnaire: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Individual Questionnaire' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('individualQuestionnaireFile'), (individualQuestionnaireFile, schema) => individualQuestionnaireFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('individualQuestionnaireFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  backgroundCheck: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Owner/Operator Background Check (BID)' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('backgroundCheckFile'), (backgroundCheckFile, schema) => backgroundCheckFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('backgroundCheckFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  proofOfInsurance: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Proof of Insurance' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('proofOfInsuranceFile'), (proofOfInsuranceFile, schema) => proofOfInsuranceFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('proofOfInsuranceFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  referencesForm: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Personal Reference Form' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ? 
        schema.when(('referencesFormFile'), (referencesFormFile, schema) => referencesFormFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('referencesFormFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  ...certificationUploadFields,
  backgroundCheckVerification: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Background Check Verification' ? 
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ? 
        schema.when(('backgroundCheckVerificationFiles'), (backgroundCheckVerificationFiles, schema) => backgroundCheckVerificationFiles.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('backgroundCheckVerificationFiles', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  additionalDocuments: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Additional Documents' ? 
      schema.when(('additionalDocumentsDoesNotApply'), (additionalDocumentsDoesNotApply, schema) => additionalDocumentsDoesNotApply ? schema : 
        schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
          schema.when(('additionalDocumentsFile'), (additionalDocumentsFile, schema) => additionalDocumentsFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
          schema.min(1, 'This field is required'))
      ) : 
      schema
    ).test('additionalDocumentsFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
})

export const UploadLocationApplicationModalSchema = Yup.object().shape({
  facilityLicense: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Copy of Facility Licensure' ? 
      schema.when(('doesNotHaveFacilityLicense'), (doesNotHaveFacilityLicense, schema) => doesNotHaveFacilityLicense ? schema : 
        schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
          schema.when(('facilityLicenseFile'), (facilityLicenseFile, schema) => facilityLicenseFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
          schema.min(1, 'This field is required'))
      ) : schema
    ).test('facilityLicenseFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  certificateInsurance: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Copy of Certificate of Insurance' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('certificateInsuranceFile'), (certificateInsuranceFile, schema) => certificateInsuranceFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('certificateInsuranceFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  debarmentAttestationLetter: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Debarment Attestation Letter' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('debarmentAttestationLetterFile'), (debarmentAttestationLetterFile, schema) => debarmentAttestationLetterFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('debarmentAttestationLetterFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  trainingAttestationLetter: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Training Attestation Letter' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('trainingAttestationLetterFile'), (trainingAttestationLetterFile, schema) => trainingAttestationLetterFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('trainingAttestationLetterFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  civilRightsComplianceAttestationLetter: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Civil Rights Compliance Attestation Letter' ? 
      schema.when(('doesNotApply'), (doesNotApply, schema) => doesNotApply ? schema : 
        schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
          schema.when(('civilRightsComplianceAttestationLetterFile'), (civilRightsComplianceAttestationLetterFile, schema) => civilRightsComplianceAttestationLetterFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
          schema.min(1, 'This field is required'))
      ) : schema
    ).test('civilRightsComplianceAttestationLetterFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  residentialWorksheet: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Residential Worksheets' ? 
      schema.when(('residentialWorksheetDoesNotApply'), (residentialWorksheetDoesNotApply, schema) => residentialWorksheetDoesNotApply ? schema : 
        schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
          schema.when(('residentialWorksheetFile'), (residentialWorksheetFile, schema) => residentialWorksheetFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
          schema.min(1, 'This field is required'))
      ) : 
      schema
    ).test('residentialWorksheetFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  certificationApplication: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Certification Application' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('certificationApplicationFile'), (certificationApplicationFile, schema) => certificationApplicationFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('certificationApplicationFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  backgroundCheck: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Owner/Operator Background Check (BID)' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('backgroundCheckFile'), (backgroundCheckFile, schema) => backgroundCheckFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('backgroundCheckFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  proofOfInsurance: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Proof of Insurance' ?
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
        schema.when(('proofOfInsuranceFile'), (proofOfInsuranceFile, schema) => proofOfInsuranceFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('proofOfInsuranceFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  ...certificationUploadFields,
  backgroundCheckVerification: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Background Check Verification' ? 
      schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ? 
        schema.when(('backgroundCheckVerificationFiles'), (backgroundCheckVerificationFiles, schema) => backgroundCheckVerificationFiles.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
        schema.min(1, 'This field is required')) :
      schema
    ).test('backgroundCheckVerificationFiles', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  additionalDocuments: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Additional Documents' ? 
      schema.when(('additionalDocumentsDoesNotApply'), (additionalDocumentsDoesNotApply, schema) => additionalDocumentsDoesNotApply ? schema : 
        schema.when(('removeFileList'), (removeFileList, schema) => removeFileList && removeFileList.length > 0 ?
          schema.when(('additionalDocumentsFile'), (additionalDocumentsFile, schema) => additionalDocumentsFile.length > removeFileList.length ? schema : schema.min(1, 'This field is required')) : 
          schema.min(1, 'This field is required'))
      ) : 
      schema
    ).test('additionalDocumentsFile', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
})

export const UploadProviderFileAuditModalSchema = Yup.object().shape({
  w9: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'W-9 In Record' ? schema.min(1, 'This field is required') : schema)
    .test('w9', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  activeCertificateLicensure: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Active Certificate/Licensure' ? schema.min(1, 'This field is required') : schema)
    .test('activeCertificateLicensure', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  activeLiabilityInsurance: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Active Liability Insurance' ? schema.min(1, 'This field is required') : schema)
    .test('activeLiabilityInsurance', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  activeHomeownersInsurance: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Active Homeowners Insurance' ? schema.min(1, 'This field is required') : schema)
    .test('activeHomeownersInsurance', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  activeAutoInsurance: Yup.array()
    .when(('modalType'), (modalType, schema) => modalType === 'Active Auto Insurance' ?schema.min(1, 'This field is required') : schema)
    .test('activeAutoInsurance', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
})

export const SubmitSchema = Yup.object().shape({
  isCertified: Yup.boolean().oneOf([true], 'Please accept you certify this information.')
})

export const AcknowledgmentSchema = Yup.object().shape({
  requiredAcknowledgment: Yup.boolean().nullable().oneOf([true], 'This field is required')
})

export const BackgroundCheckVerificationSchema = Yup.object().shape({
  bidDate1: Yup.date().nullable()
    .when(('notApplicable1'), (notApplicable, schema) => !notApplicable ? schema.required('This field is required.') : schema),
  dojDate1: Yup.date().nullable()
    .when(('notApplicable1'), (notApplicable, schema) => !notApplicable ? schema.required('This field is required.') : schema),
  dhsFile1: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable1 && this.parent.dhsFile1.length === 0) return false
      return true
    })
    .test('dhsFile1', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  dojFile1: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable1 && this.parent.dojFile1.length === 0) return false
      return true
    })
    .test('dojFile1', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  bidFile1: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable1 && this.parent.bidFile1.length === 0) return false
      return true
    })
    .test('bidFile1', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  comments1: Yup.string().nullable().max(500, 'Please use 50 characters or less.'),
  bidDate2: Yup.date().nullable()
    .when(('notApplicable2'), (notApplicable, schema) => !notApplicable ? schema.required('This field is required.') : schema),
  dojDate2: Yup.date().nullable()
    .when(('notApplicable2'), (notApplicable, schema) => !notApplicable ? schema.required('This field is required.') : schema),
  dhsFile2: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable2 && this.parent.dhsFile2.length === 0) return false
      return true
    })
    .test('dhsFile2', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  dojFile2: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable2 && this.parent.dojFile2.length === 0) return false
      return true
    })
    .test('dojFile2', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  bidFile2: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable2 && this.parent.bidFile2.length === 0) return false
      return true
    })
    .test('bidFile2', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  comments2: Yup.string().nullable().max(500, 'Please use 50 characters or less.'),
  bidDate3: Yup.date().nullable()
    .when(('notApplicable3'), (notApplicable, schema) => !notApplicable ? schema.required('This field is required.') : schema),
  dojDate3: Yup.date().nullable()
    .when(('notApplicable3'), (notApplicable, schema) => !notApplicable ? schema.required('This field is required.') : schema),
  dhsFile3: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable3 && this.parent.dhsFile3.length === 0) return false
      return true
    })
    .test('dhsFile3', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  dojFile3: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable3 && this.parent.dojFile3.length === 0) return false
      return true
    })
    .test('dojFile3', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  bidFile3: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable3 && this.parent.bidFile3.length === 0) return false
      return true
    })
    .test('bidFile3', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  comments3: Yup.string().nullable().max(500, 'Please use 50 characters or less.'),
  bidDate4: Yup.date().nullable()
    .when(('notApplicable4'), (notApplicable, schema) => !notApplicable ? schema.required('This field is required.') : schema),
  dojDate4: Yup.date().nullable()
    .when(('notApplicable4'), (notApplicable, schema) => !notApplicable ? schema.required('This field is required.') : schema),
  dhsFile4: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable4 && this.parent.dhsFile4.length === 0) return false
      return true
    })
    .test('dhsFile4', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  dojFile4: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable4 && this.parent.dojFile4.length === 0) return false
      return true
    })
    .test('dojFile4', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  bidFile4: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (!this.parent.notApplicable4 && this.parent.bidFile4.length === 0) return false
      return true
    })
    .test('bidFile4', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  comments4: Yup.string().nullable().max(500, 'Please use 50 characters or less.'),
})

export const OrganizationDetailSchema = Yup.object().shape({
  openings: Yup.number().nullable().min(0, 'Please specify values equal or greater than zero.'),
})

export const ServiceVerificationAuditSchema = Yup.object().shape({
  file: Yup.array()
    .test('isRequired', 'This field is required.', function () {
      if (this.parent.file.length < 0 || ( this.parent.removeFile.length >= this.parent.uploadedFile.length && this.parent.file.length === 0 )) return false
      return true
    })
    .test('file', 'A file name can\'t contain any of the following characters: \ / : * ? " < > |', (value) => {
      if ( value.length > 0 ) {
        return value.every( item => {
          const fileNameExp = /[/\\?*:|"<>]/g
          return !fileNameExp.test(item.name)
        })
      } else {
        return true
      }
    }),
  comments: Yup.string().nullable().max(500, 'Please use 50 characters or less.'),
})